import type { FloatingTooltipState } from "../../hooks/useFloatingTooltip";


interface FloatingTooltipProps {
  tooltip: FloatingTooltipState | null;
  zIndex?: number;
}

export default function FloatingTooltip({ tooltip, zIndex = 10000 }: FloatingTooltipProps) {
  if (!tooltip) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed -translate-x-1/2 -translate-y-full whitespace-nowrap rounded-sm bg-black-alpha-90 px-lg py-md [font-family:Lato,sans-serif] text-[14px] text-white shadow-[0_4px_12px_var(--color-black-alpha-30)]"
      style={{
        left: `${tooltip.x}px`,
        top: `${tooltip.y}px`,
        zIndex,
      }}
    >
      {tooltip.text}
    </div>
  );
}
